import Vue from 'vue'
import pricing from '@/pricing'
import util from '@/util'

const setCurrentUser = (state, payload) => {
  // eslint-disable-next-line global-require
  state.currentUser = {
    rememberSettings: {},
    ...payload,
  }
  state.workingMode = util.getWorkingMode()
}

const setIsTokenValid = (state, payload) => {
  state.isTokenValid = payload
}

const setPlan = (state, payload) => {
  // An already-built plan object passes straight through (callers that resolved
  // the plan themselves, e.g. the redeem flow).
  if (payload && typeof payload === 'object') {
    state.plan = payload
    return
  }
  const staticPlan = pricing.getPlanByType(payload)
  if (staticPlan) {
    state.plan = staticPlan
    return
  }
  // Unknown bucket → a marketplace / one-time product configured in Stripe only.
  // Build a display plan from the BE-provided name carried on the latest /my-plan
  // payload (stored on currentUser by setCurrentUser, always committed just before
  // setPlan), so the badge + My Plan page show the real product name — no
  // per-product FE code. Without a name it degrades to a generic Lifetime label
  // (still a valid non-free plan) rather than the old `undefined`.
  const subscription = state.currentUser
    && state.currentUser.myPlan
    && state.currentUser.myPlan.subscription
  state.plan = pricing.buildMarketplacePlan({
    type: payload,
    name: subscription && subscription.planName,
    billingCycle: (subscription && subscription.billingCycle) || 'lifetime',
  })
}

const setIsTrialPlan = (state, payload) => {
  state.isTrialPlan = payload
}

const updateCurrentUser = (state, payload) => {
  if (!state.currentUser || !state.currentUser.id) return
  state.currentUser = {
    ...state.currentUser,
    ...payload,
  }
}

const updateCurrentABTest = (state, payload) => {
  if (!state.currentUser || !state.currentUser.id) return
  Vue.set(state.currentUser, 'abTest', {
    ...state.currentUser.abTest,
    ...payload,
  })
}

const setLimitationPresentation = (state, payload) => {
  state.planBenefitLimitation = {
    ...state.planBenefitLimitation,
    ...payload,
  }
}
const setUserSetting = (state, payload) => {
  state.currentUser.userSetting = {
    ...state.currentUser.userSetting,
    ...payload,
  }
}
export default {
  setCurrentUser,
  setIsTokenValid,
  setPlan,
  updateCurrentUser,
  updateCurrentABTest,
  setIsTrialPlan,
  setLimitationPresentation,
  setUserSetting,
}
